import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { useVideaNotesApi } from '../context';

import type { UpdateNotesBody } from './types';

export interface UpdateNotesMutationVariables {
  clinicalNoteId: string;
  updateNotesBody: UpdateNotesBody;
}

export const useUpdateNotes = (
  options?: Omit<
    UseMutationOptions<void, Error, UpdateNotesMutationVariables>,
    'mutationFn'
  >,
) => {
  const { patchNoteSummary } = useVideaNotesApi();

  return useMutation<void, Error, UpdateNotesMutationVariables>({
    ...options,
    mutationFn: async ({ clinicalNoteId, updateNotesBody }) => {
      const isPatched = await patchNoteSummary(
        clinicalNoteId,
        updateNotesBody as Record<string, unknown>,
      );

      if (!isPatched) {
        throw new Error('Failed to update note');
      }
    },
  });
};
